import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { Icon } from 'components';
// eslint-disable-next-line
import { ComponentRegistry } from 'core/index';
import { Tag } from 'legacyComponents/styled/lib';

export const DefaultItemComponent = observer(({ deleteHandler, item }) => {
  const deleteKey = `${item}-delete`;
  const deleteButton = (
    <IconStyled
      name='close'
      size='8px'
      onClick={() => deleteHandler(item)}
      key={deleteKey}
    />
  );
  return (
    <Wrapper key={item}>
      <span>{item}</span>
      {deleteButton}
    </Wrapper>
  );
});

const IconStyled = styled(Icon)`
  margin-left: 10px;
  vertical-align: baseline;
  color: ${props => props.theme.color.wfOrange};
  &:hover {
    transform: scale(1.3);
  }
`;

const Wrapper = styled(Tag)`
  padding: 4px;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
  > span:nth-of-type(2) {
    margin-right: 5px;
  }
`;
